<div>
  <div class="container" id="login">
    <div class="row">
      <div class="col-md-12">
        <h1>Log in to begin:</h1>
        <p>To log in, enter your Dealer ID and password.</p>
      </div>
    </div>
    <div *ngIf="message" role="alert" class="formError text-danger" aria-live="assertive">
      <p>{{message}}</p>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="row mb-2">
        <div class="col-md-12">
          <div>All fields are required.</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="form-group">
            <label for="dealerID">Dealer ID</label>
            <input id="dealerID" type="text" formControlName="username"
                   class="form-control required" aria-required="true" [ngClass]="{'is-invalid': hasError('username')}"
                   aria-label="dealer id" [attr.aria-invalid]="hasError('username')" required />
            <div *ngIf="hasError('username')" role="alert" class="formError text-danger" aria-live="assertive">
              <div *ngIf="hasError('username', 'required')">Required</div>
              <div *ngIf="hasError('username','validDealerId')" role="alert" class="formError text-danger" aria-live="assertive">
                Please, enter a valid Dealer Id.
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="form-group">
            <label for="dealerPassword">Password</label>
            <input id="dealerPassword" type="password" formControlName="password"
                   class="form-control required" aria-required="true" [ngClass]="{'is-invalid': hasError('password')}"
                   aria-label="dealer password" [attr.aria-invalid]="hasError('password')" required />
            <div *ngIf="hasError('password')" role="alert" class="formError text-danger" aria-live="assertive">
              <div *ngIf="hasError('password', 'required')">Required</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p>Forgot your password? <a href="#" (click)="resetPassword()">Reset it</a>.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="submit" [disabled]="loginForm.touched && !loginForm.valid"
                  class="btn btn-primary btn mb-3"><i class="fas fa-sign-in-alt"></i> Log In</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12"><p>By using this service, you confirm that you have read, understand, and agree with the
          <a [routerLink]="['/disclaimer']" target="_blank">Disclaimer</a>.</p></div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <h2>Public License Search</h2> <a [routerLink]="['/public-license-search']" class="btn btn-primary" target="_blank">CMLS Public License Search</a>
        </div>
      </div>
    </form>
  </div>
</div>
